import {gql} from 'apollo-boost';

export const GET_CLASSROOMSOWNED = gql`
  query getClassRoomsOwned{
    getClassRoomsOwned {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
    }
  }
`;

export const GET_AVAILABLE_CLASSROOMSOWNED = gql`
  query getAvailableClassRoomsOwned{
    getAvailableClassRoomsOwned {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
      label
    }
  }
`;

export const GET_CLASSROOMOWNED = gql`
  query getClassRoomOwned($id : ID!){
    getClassRoomOwned (
      id: $id
    ) {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
    }
  }
`;

export const ADD_CLASSROOMOWNED = gql`
  mutation addClassRoomOwned(
    $classRoomTypeId: ID!
    $classRoomOwnedInput: ClassRoomOwnedInput!
  ) {
    addClassRoomOwned(
      classRoomTypeId: $classRoomTypeId
      classRoomOwnedInput: $classRoomOwnedInput
    ) {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
    }
  }
`;

export const UPDATE_CLASSROOMOWNED = gql`
  mutation updateClassRoomOwned(
    $id: ID!,
    $classRoomTypeId: ID!
    $classRoomOwnedInput: ClassRoomOwnedInput!
  ) {
    updateClassRoomOwned(
      id: $id
      classRoomTypeId: $classRoomTypeId
      classRoomOwnedInput: $classRoomOwnedInput
    ) {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
    }
  }
`;

export const DELETE_CLASSROOMOWNED = gql`
  mutation deleteClassRoomOwned($id: ID!) {
    deleteClassRoomOwned(
      id: $id
    ) {
      id
      inUseClassRoomQty
      availableClassRoomQty
      maxClassRoomQty
      capacity
      startDate
      endDate
      classRoomType{
        id nameLocal nameEng capacity label
      }
    }
  }
`;

